module.exports = __webpack_public_path__ + "img/map-pin.88802991.svg";